module.exports = __webpack_public_path__ + "static/media/123.83693e35.jpg";